/**
 * Maps the i18next UI language ("fr", "en", "fr-FR"…) to the Intl locale used
 * to format dates and amounts, so French users don't get the en-US defaults of
 * Intl / the design-system formatDate.
 */
export function toIntlLocale(language: string | null | undefined): string {
  return language?.toLowerCase().startsWith("fr") ? "fr-FR" : "en-US";
}

/**
 * Formats an amount in FCFA for the given UI language: French grouping
 * (narrow no-break spaces, "20 000 FCFA") for fr, "20,000 FCFA" for en.
 * `useGrouping: false` gives a parse-friendly "20000 FCFA" for CSV exports,
 * where locale separators would break spreadsheet number parsing.
 */
export function formatMoney(
  amount: number | null | undefined,
  language: string | null | undefined,
  options: { useGrouping?: boolean } = {}
): string {
  if (amount === undefined || amount === null) return "—";
  const locale = options.useGrouping === false ? "en-US" : toIntlLocale(language);
  const formatted = new Intl.NumberFormat(locale, {
    useGrouping: options.useGrouping ?? true,
  }).format(amount);
  return `${formatted} FCFA`;
}
